import CityPageTemplate from "../city-template/CityPageTemplate";
import { fishersConfig } from "./data";

export default function FishersPage() {
  return <CityPageTemplate config={fishersConfig} />;
}